// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__34lWZ","notes":"Notes_notes__1k6t3"};